import React from 'react';
import SearchIcon from '../../images/icons/SearchIcon'

class UserSearch extends React.Component {
    constructor({ onSearch }) {
        super()
        this.state = {
            'search_text': ''
        }
        this.onSearch = onSearch.bind(this)
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    onSearchChange(e) {
        const { value } = e.target;

        this.setState({'search_text': value});
        this.onSearch(value)
    }



    render() {
        const { search_text } = this.state;
        return (<div >
            <div className="search-box__content">
                <div className="search-box__input">
                    <SearchIcon />
                    <input type="search" onChange={this.onSearchChange} value={search_text} placeholder="Search for Users"/>
                </div>
            </div>
        </div>)
    }
}

export default UserSearch



// WEBPACK FOOTER //
// ./src/components/user/UserSearch.jsx